import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useApi, useFetch } from '@hooks';
import { useSaveServiceResponse } from '@store';
import { AccountLoginInputDto, AccountLoginOutputDto, AccountLoginOutputDtoSingleOutputMessage } from '@types';

export const useFetchAccountLogin = (): UseFetchHookOutput<AccountLoginInputDto, AccountLoginOutputDto> => {
	const { accountLogin: fetchAccountLogin } = useApi();
	const saveServiceResponse = useSaveServiceResponse();

	return useFetch<AccountLoginInputDto, AccountLoginOutputDto>({
		input: {
			fetchFn: fetchAccountLogin,
			onSuccess: (res: AccountLoginOutputDtoSingleOutputMessage) => {
				saveServiceResponse({ accountLogin: res.data });
			},
		},
		requestName: 'account/login',
	});
};
